import { documentationActions } from '../../actions/constant';

const { GET_EOC_EDIT_DOCUMENT_DATA, RESET_EOC_EDIT_DOCUMENT_DATA } = documentationActions;

const initialState: object = {
  document: null,
  episodeOfCareId: null,
  patientData: null,
  activeTab: null,
};

export const eocEditDocumentDataReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_EOC_EDIT_DOCUMENT_DATA: {
      return {
        document: action.payload.document,
        episodeOfCareId: action.payload.episodeOfCareId,
        patientData: action.payload.patientData,
        activeTab: action.payload.activeTab,
      };
    }

    case RESET_EOC_EDIT_DOCUMENT_DATA:
      return initialState;

    default:
      return state;
  }
};
